document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartProgressBar', ({ threshold, progressColor, backgroundColor, beforeMessage, afterMessage }) => {
    return {
      threshold: threshold,
      progressColor: progressColor,
      backgroundColor: backgroundColor,
      beforeMessage: beforeMessage,
      afterMessage: afterMessage,
      progress: 0,
      message: '',
      isVisible: false,
      
      init() {
        this.fetchCartAndUpdate();
        
        // Listen for cart updates
        document.body.addEventListener('switch:cart:afteradditem', () => {
          this.fetchCartAndUpdate();
        });
        
        document.body.addEventListener('switch:modalcart:cartqtychange', () => {
          this.fetchCartAndUpdate();
        });
      },
      
      fetchCartAndUpdate() {
        fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(cart => {
            this.updateProgress(cart);
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
          });
      },
      
      updateProgress(cart) {
        const itemCount = cart.item_count || 0;
        const currentTotal = cart.total_price || 0;
        const remaining = this.threshold - currentTotal;
        
        // Show/hide based on cart count
        this.isVisible = itemCount > 0;
        
        // Calculate progress percentage
        this.progress = Math.min((currentTotal / this.threshold) * 100, 100);
        
        // Update message
        if (remaining > 0) {
          // Before threshold
          const remainingFormatted = this.formatMoney(remaining);
          this.message = this.beforeMessage.replace('||amount||', remainingFormatted);
        } else {
          // After threshold
          this.message = this.afterMessage;
        }
      },
      
      formatMoney(cents) {
        // Use Shopify's money format or basic formatting
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, window.theme.moneyFormat || '${{amount}}');
        }
        
        // Fallback formatting
        const dollars = (cents / 100).toFixed(2);
        return `$${dollars}`;
      }
    };
  });
});
